'use client';

import dynamic from 'next/dynamic';

export const SpringVsEase = dynamic(() => import('./SpringVsEase'), {
  ssr: true,
});
export const SpringComparison = dynamic(
  () => import('./SpringComparison')
);
export const SpringMechanism = dynamic(
  () => import('./SpringMechanism')
);
export const Environment = dynamic(() => import('./Environment'));
export const SpringPhysicsSandbox = dynamic(
  () => import('./SpringPhysicsSandbox')
);
